import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Channel } from '../../models/channel';
import { ReferentialEntity } from '../../models/referential-entity';
import { Country } from '../../models/country';

export const FILTERS_ACTIONS = {
  SET_DATES: 'SET_DATES',
  SET_FILTERS: 'SET_FILTERS'
};

export const FILTERS_SAVED = "filterSaved";

export interface FiltersStateInterface {
  startDate: Date;
  endDate: Date;
  year: number;
  week: number;
  sameDay: boolean;
  edited: boolean;
  channels: Channel[];
  referentialEntities: ReferentialEntity[];
  keywords: string;
  idValue: string;
  forceLanguageInter: boolean;
  broadcastingCountries: Country[];
  languageId: number;
  defaultDestination: string;
  field: string;
  fieldStatus: string;
  filterDestination: string;
  idType: string;
  fromDashboard: boolean;
  midnightMode: boolean;
  updatedInTheLastHours: number;
  showHidden: boolean;
}

@Injectable()
export class FiltersActions {

  constructor(private store: Store<FiltersStateInterface>) { }

  setDates(startDate: Date, endDate: Date, midnightMode: boolean) {
    this.store.dispatch({ type: FILTERS_ACTIONS.SET_DATES, payload: { startDate: startDate, endDate: endDate, midnightMode: midnightMode, week: null, year: startDate.getFullYear() } });
  }

  setFilters(filters: FiltersStateInterface) {
    this.store.dispatch({ type: FILTERS_ACTIONS.SET_FILTERS, payload: filters });
  }
}


// WEBPACK FOOTER //
// ./src/app/store/actions/filters.actions.ts